<template>
  <div class="admin">
    <el-tabs v-model="currentTab" @tab-click="onMainTabClick">
      <el-tab-pane
        v-for="group in visibleGroups"
        :key="group.index"
        :label="group.label"
        :name="group.index"
      />
    </el-tabs>
    <el-tabs v-model="currentSubTab" @tab-click="onSubTabClick">
      <el-tab-pane
        v-for="item in currentSubItems"
        :key="item.segment"
        :label="item.label"
        :name="item.subIndex"
      />
    </el-tabs>
    <router-view />
  </div>
</template>

<script>
const GROUPS = [
  { index: "0", label: "User's MGT" },
  { index: "1", label: "Big Data" },
  { index: "2", label: "AI MGT" },
  { index: "3", label: "AI Agent" },
  { index: "4", label: "Report" },
  { index: "5", label: "ETC MGT" },
  { index: "6", label: "APP" },
];

const ADMIN_ITEMS = [
  { segment: "user", index: "0", subIndex: "00", label: "Users", roles: ["root"] },
  { segment: "organization", index: "0", subIndex: "01", label: "Organization", roles: ["root"] },
  { segment: "role", index: "0", subIndex: "02", label: "Role", roles: ["root"] },
  { segment: "user-services", index: "0", subIndex: "03", label: "User Services", roles: ["root"] },
  { segment: "brands", index: "0", subIndex: "04", label: "Brands", roles: ["root"] },
  { segment: "user-brands", index: "0", subIndex: "05", label: "User Brands & Items", roles: ["root"] },
  { segment: "notification", index: "0", subIndex: "06", label: "Notification", roles: ["root"] },
  { segment: "crawling-sales", index: "1", subIndex: "10", label: "Crawling Sales", roles: ["root", "checker"] },
  { segment: "crawling-stock", index: "1", subIndex: "11", label: "Crawling Stock", roles: ["root"] },
  { segment: "tagger-check", index: "1", subIndex: "12", label: "Tagger Check", roles: ["root", "checker"] },
  { segment: "category", index: "2", subIndex: "20", label: "Category", roles: ["root"] },
  { segment: "nlp-task", index: "2", subIndex: "21", label: "NLP Task", roles: ["root"] },
  { segment: "nlp-analysis", index: "2", subIndex: "22", label: "Keyword Analysis", roles: ["root"] },
  { segment: "gpt", index: "2", subIndex: "23", label: "GPT", roles: ["root"] },
  { segment: "gpt-concept", index: "2", subIndex: "24", label: "GPT Concept", roles: ["root"] },
  { segment: "gpt-designer", index: "2", subIndex: "25", label: "GPT Designer", roles: ["root"] },
  { segment: "gpt-drawing", index: "2", subIndex: "26", label: "GPT Drawing", roles: ["root"] },
  { segment: "gpt-upscaling", index: "2", subIndex: "27", label: "GPT Upscaling", roles: ["root"] },
  { segment: "gpt-target-face", index: "2", subIndex: "28", label: "GPT Target", roles: ["root"] },
  { segment: "agent-qa", index: "3", subIndex: "30", label: "Q&A Agent", roles: ["root"] },
  { segment: "board", index: "4", subIndex: "40", label: "Weekly Board", roles: ["root"] },
  { segment: "trend-insight", index: "4", subIndex: "41", label: "Weekly Trend Insight", roles: ["root"] },
  { segment: "user-report", index: "4", subIndex: "42", label: "User Report", roles: ["root"] },
  { segment: "image-trend-map", index: "4", subIndex: "43", label: "Image Trend Map", roles: ["root"] },
  { segment: "image-trend-map-detail", index: "4", subIndex: "44", label: "Image Trend Map (Brands&Items)", roles: ["root"] },
  { segment: "user-data", index: "4", subIndex: "45", label: "User Data", roles: ["root"] },
  { segment: "drives", index: "5", subIndex: "50", label: "Drives", roles: ["root"] },
  { segment: "visual-files", index: "5", subIndex: "51", label: "Visual Files", roles: ["root"] },
  { segment: "global-trends", index: "5", subIndex: "52", label: "Global Trend", roles: ["root"] },
  { segment: "cores", index: "5", subIndex: "53", label: "Cores", roles: ["root"] },
  { segment: "app-subscription-plan", index: "6", subIndex: "60", label: "Subscription Plan", roles: ["root"] },
  { segment: "app-subscription-user-plan", index: "6", subIndex: "61", label: "Subscription User Plan", roles: ["root"] },
  { segment: "app-subscription-order", index: "6", subIndex: "62", label: "Subscription Order", roles: ["root"] },
];

export default {
  name: "Admin",
  data() {
    return {
      currentTab: "",
      currentSubTab: "",
    };
  },
  computed: {
    adminType() {
      return this.$store.getters.my && this.$store.getters.my.adminType
        ? this.$store.getters.my.adminType
        : "";
    },
    visibleItems() {
      return ADMIN_ITEMS.filter((item) => item.roles.includes(this.adminType));
    },
    visibleGroups() {
      return GROUPS.filter((group) =>
        this.visibleItems.some((item) => item.index === group.index)
      );
    },
    currentSubItems() {
      return this.visibleItems.filter((item) => item.index === this.currentTab);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.syncByRoute();
      },
    },
    adminType() {
      this.syncByRoute();
    },
  },
  methods: {
    getSegmentFromPath() {
      return this.$route.path.startsWith("/admin/")
        ? this.$route.path.slice("/admin/".length)
        : "";
    },
    findBySegment(segment) {
      return this.visibleItems.find((item) => item.segment === segment);
    },
    findBySubIndex(subIndex) {
      return this.visibleItems.find(
        (item) => item.subIndex === subIndex && item.index === this.currentTab
      );
    },
    firstSubItem(index) {
      return this.visibleItems.find((item) => !index || item.index === index);
    },
    goToItem(item, replace = false) {
      const path = `/admin/${item.segment}`;
      if (this.$route.path === path) {
        return;
      }
      const action = replace ? "replace" : "push";
      this.$router[action](path).catch(() => {});
    },
    syncByRoute() {
      if (!this.visibleItems.length) {
        this.currentTab = "";
        this.currentSubTab = "";
        return;
      }
      const current = this.findBySegment(this.getSegmentFromPath());
      if (!current) {
        this.goToItem(this.firstSubItem(), true);
        return;
      }
      this.currentTab = current.index;
      this.currentSubTab = current.subIndex;
    },
    onMainTabClick() {
      const target = this.firstSubItem(this.currentTab);
      if (target) {
        this.goToItem(target);
      }
    },
    onSubTabClick() {
      const target = this.findBySubIndex(this.currentSubTab);
      if (target) {
        this.goToItem(target);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.admin {
  padding: 10px 20px 0;
}
</style>
